import React from 'react'
import {Switch, Route} from 'react-router-dom'
import List from './List'
import Show from './Show'
import './index.scss'

const Orders = ({match}) => {
  return (
    <Switch>
      <Route path={`${match.path}/:orderId`} component={Show} />
      <Route path={match.path} component={List} />
    </Switch>
  )
}

export default Orders
